module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-desktop-es.9b5ba17d.webp";